export var REFERENCE_FRAME;
(function (REFERENCE_FRAME) {
    REFERENCE_FRAME["TEME"] = "TEME";
    REFERENCE_FRAME["EME2000"] = "EME2000";
    REFERENCE_FRAME["MJ2000"] = "MJ2000";
    REFERENCE_FRAME["EARTH_FIXED"] = "ITRF";
    REFERENCE_FRAME["INERTIAL"] = "GCRF";
})(REFERENCE_FRAME || (REFERENCE_FRAME = {}));
export var UNITS_DEF;
(function (UNITS_DEF) {
    UNITS_DEF["DEG"] = "DEG";
    UNITS_DEF["RAD"] = "rad";
    UNITS_DEF["M"] = "M";
    UNITS_DEF["M_S"] = "M_S";
    UNITS_DEF["M_S2"] = "M_S_2";
    UNITS_DEF["M2"] = "M_2";
    UNITS_DEF["M2_S"] = "M_2_S";
    UNITS_DEF["M2_S_2"] = "M_2_S_2";
    UNITS_DEF["KM"] = "KM";
    UNITS_DEF["KM_S"] = "KM_S";
    UNITS_DEF["KM_S2"] = "KM_S_2";
    UNITS_DEF["KM2"] = "KM_2";
    UNITS_DEF["KM2_S"] = "KM_2_S";
    UNITS_DEF["KM2_S2"] = "KM_2_S_2";
    UNITS_DEF["GM"] = "km**3/s**2";
    UNITS_DEF["KG"] = "kg";
})(UNITS_DEF || (UNITS_DEF = {}));
//# sourceMappingURL=types.js.map